"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preparePrintDesignData = exports.prepareDesignDataSnapshots = exports.getMatchAt = exports.embeddedSvgImageToInlineSvgContent = exports.alterObjectValues = exports.alterArrayValues = void 0;
var getMatchAt = exports.getMatchAt = function getMatchAt(str, regexp) {
  var idx = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var matches = ('' + str).match(regexp);
  return matches && matches[idx] || defaultValue;
};
var embeddedSvgImageToInlineSvgContent = exports.embeddedSvgImageToInlineSvgContent = function embeddedSvgImageToInlineSvgContent(svgStr) {
  return svgStr.replace(/<image([^>]+)xlink:href="data:image\/svg\+xml;base64,([^"]+)"[^>]*>/g, function (_, attributesStr, base64Str) {
    var x = getMatchAt(attributesStr, /x="([^"]+)"/, 1, 0);
    var y = getMatchAt(attributesStr, /y="([^"]+)"/, 1, 0);
    var transform = getMatchAt(attributesStr, /transform="([^"]+)"/, 1, '');
    var svgContent = atob(base64Str).replace(/(<\?xml[^>]+>)|(<!--[^>]+-->)/gi, '');
    return "<g transform=\"".concat(transform, " translate(").concat(x, ",").concat(y, ")\">").concat(svgContent, "</g>");
  });
};
var alterObjectValues = exports.alterObjectValues = function alterObjectValues(obj, fn) {
  Object.keys(obj).forEach(function (key) {
    obj[key] = fn(obj[key], key);
  });
  return obj;
};
var alterArrayValues = exports.alterArrayValues = function alterArrayValues(arr, fn) {
  arr.forEach(function (value, key) {
    arr[key] = fn(value, key);
  });
  return arr;
};
var prepareDesignDataSnapshots = exports.prepareDesignDataSnapshots = function prepareDesignDataSnapshots(svgArrMap) {
  return alterObjectValues(svgArrMap, function (arr) {
    return alterArrayValues(arr, embeddedSvgImageToInlineSvgContent);
  });
};
var preparePrintDesignData = exports.preparePrintDesignData = function preparePrintDesignData(svgMap) {
  return alterObjectValues(svgMap, embeddedSvgImageToInlineSvgContent);
};